import MyProfile from "../../../jsx/components/Dashboard/MyProfile/myprofile";

const MyProfileWrapper = () => {
  return <MyProfile />;
};

export const allowedRoles = [_enum.ROUTE_PERSONAS.customer];
export default constore(MyProfileWrapper);
